import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDBvXIbrnVR3KTgmYxWMrdwZf-g1CPFEUU",
  authDomain: "resturantapp-e9611.firebaseapp.com",
  projectId: "resturantapp-e9611",
  storageBucket: "resturantapp-e9611.firebasestorage.app",
  messagingSenderId: "155705545330",
  appId: "1:155705545330:web:e36e9729f45dd84407a8eb"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
